// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"styles__loadingWrapper___2cY_3","moduleTypeTitle":"styles__moduleTypeTitle___2ZyWB","container":"styles__container___1XKb1"};